import api from './api';

export const analyticsAPI = {
  getDashboard: (params) => api.get('/api/analytics/management/dashboard', { params }),
  getPulse: (params) => api.get('/api/analytics/management/pulse', { params }),
  getFunnel: (params) => api.get('/api/analytics/management/funnel', { params }),
  getFollowUpAgeing: () => api.get('/api/analytics/management/follow-up-ageing'),
  getStuckLeads: (params) => api.get('/api/analytics/management/follow-up-ageing/leads', { params }),
  getBySource: (params) => api.get('/api/analytics/management/by-source', { params }),
  getByCountry: (params) => api.get('/api/analytics/management/by-country', { params }),
  getBySales: (params) => api.get('/api/analytics/management/by-sales', { params }),
  getByTrainer: (params) => api.get('/api/analytics/management/by-trainer', { params }),
  getRevenueTrend: (params) => api.get('/api/analytics/management/revenue-trend', { params }),
  getDemoBreakdown: (demoId) => api.get(`/api/analytics/demos/${demoId}/breakdown`),
};

export default analyticsAPI;
